"use client";

import {
  type AnalyticsProperties,
  type PostHogEvent,
} from "modules/common/analytics/events";
import { getLoadedPostHog } from "utils/posthog-client";

export function captureClientEvent(
  event: PostHogEvent,
  properties?: AnalyticsProperties
): void {
  getLoadedPostHog()?.capture(event, {
    source: "web_app",
    ...properties,
  });
}
